<template>
  <InfoMessage width="492" class="mx-auto" :show-close="false">
    <template #body>
      <div class="text-h2 text-center mb-8">{{ $t('goPayStep.title') }}</div>
      <div class="py-6 text-center border price-box">
        <span class="text-h1">{{ prices.czk }}{{ $t('currency') }}</span>
        <span class="text-h3 grey-darken-1--text">{{ $t('goPayStep.priceSuffix') }}</span>
      </div>
      <div class="payments text-center pt-2 pb-1 border">
        <v-img
          :width="35"
          :height="12"
          class="mr-3"
          contain
          :src="$asset('img/logos/payments/onlineIos.png')"
        />
        <v-img
          :width="32"
          :height="12"
          class="mr-2"
          contain
          :src="$asset('img/logos/payments/onlineAndroid.png')"
        />
        <v-img
          :width="95"
          :height="20"
          contain
          :src="$asset('img/logos/payments/card_additional.png')"
        />
      </div>
      <div class="mt-6">{{ $t('goPayStep.subtitle', { priceCzk: prices.czk }) }}</div>
    </template>
    <template #action>
      <v-btn block @click="redirectToGopay">{{ $t('goPayStep.button') }}</v-btn>
    </template>
  </InfoMessage>
</template>

<script>
import InfoMessage from '@/components/Atoms/InfoMessage.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'UaGoPay',
  components: { InfoMessage },
  computed: {
    ...mapGetters({
      returnData: 'dynamicForms/returnData'
    })
  },
  methods: {
    redirectToGopay() {
      window.location.assign(this.returnData.providersPaymentToken);
    }
  }
};
</script>

<style lang="scss" scoped>
.price-box {
  border-top-right-radius: map-get($rounded, 'lg');
  border-top-left-radius: map-get($rounded, 'lg');
}
#app .payments {
  border-top: none !important;
  border-bottom-right-radius: map-get($rounded, 'lg');
  border-bottom-left-radius: map-get($rounded, 'lg');

  & > div {
    display: inline-block;
    top: -3px;
  }
  & > div:last-child {
    top: 0;
  }
}
</style>
